module.exports = __webpack_public_path__ + "static/media/fadi.1fd0abd3.jpg";